function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { useEffect, useState } from "react";

function useFeedSettings(feedClient) {
  var [settings, setSettings] = useState(null);
  var [isLoading, setIsLoading] = useState(false); // TODO: consider moving this into the feed client and into the feed store state when
  // we're using this in other areas of the feed

  useEffect(() => {
    function getSettings() {
      return _getSettings.apply(this, arguments);
    }

    function _getSettings() {
      _getSettings = _asyncToGenerator(function* () {
        var knock = feedClient.knock;
        var apiClient = knock.client();
        var feedSettingsPath = "/v1/users/".concat(knock.userId, "/feeds/").concat(feedClient.feedId, "/settings");
        setIsLoading(true);
        var response = yield apiClient.makeRequest({
          method: "GET",
          url: feedSettingsPath
        });

        if (!response.error) {
          setSettings(response.body);
        }

        setIsLoading(false);
      });
      return _getSettings.apply(this, arguments);
    }

    getSettings();
  }, []);
  return {
    settings,
    loading: isLoading
  };
}

export default useFeedSettings;
//# sourceMappingURL=useFeedSettings.js.map